import React from 'react';
const BULLETS = [{
  lead: 'Операция по квоте ОМС — бесплатно.',
  text: 'Помогаем оформить документы. Сама операция и пребывание в стационаре оплачиваются государством.'
}, {
  lead: 'Дорога и проживание — за счёт пациента',
  text: 'Ориентировочно 15-25 тысяч рублей. Организация поездки на вашей стороне.'
}, {
  lead: 'Принимаем пациентов из всех регионов',
  text: 'Многие приезжают из далёких городов — для нас это привычная практика.'
}];
const REVIEWS = [{
  header: 'Татьяна - прилетела из Екатеринбурга',
  text: 'Очень переживала из-за перелёта. Но всё было организовано чётко. Помогли с документами, встретили в отделении. На 5-й день уже выписали.'
}, {
  header: 'Сергей - прилетел из Новосибирска',
  text: 'Долго откладывал операцию из-за страха. После онлайн-консультации решился. В палате комфортно, сейчас прохожу реабилитацию дома, сустав не болит.'
}];
export function ComingToSpb() {
  return <section className="w-full bg-white" data-id="element-12">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-6 lg:py-20" data-id="element-13">
        <h2 className="max-w-2xl text-xl font-semibold leading-tight tracking-tight text-slate-900 sm:text-2xl lg:text-3xl" data-id="element-14">
          Для операции нужно приехать в Петербург. Вот что важно знать
        </h2>

        <div className="mt-10 grid gap-10 lg:grid-cols-2 lg:items-start lg:gap-14" data-id="element-15">
          <ul className="space-y-6" data-id="element-16">
            {BULLETS.map(bullet => <li key={bullet.lead} className="flex gap-4" data-id="element-17">
                <span className="mt-2.5 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-blue-600" aria-hidden="true" data-id="element-18" />
                <p className="text-lg leading-relaxed text-slate-600" data-id="element-19">
                  <span className="font-semibold text-slate-900" data-id="element-20">
                    {bullet.lead}
                  </span>{' '}
                  {bullet.text}
                </p>
              </li>)}
          </ul>

          <div className="overflow-hidden rounded-3xl border border-slate-100 bg-slate-50 shadow-sm" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/jzvRHmMPbJ5UeeeknXtqeW/chad_5472d8c6408f4407a3f95fd1ab354c29.png" alt="Здание современного ортопедического центра в Санкт-Петербурге" className="h-64 w-full object-cover sm:h-80 lg:h-96" data-id="element-22" />
          </div>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-23">
          {REVIEWS.map(review => <figure key={review.header} className="rounded-2xl border border-blue-100 bg-blue-50/50 p-6" data-id="element-24">
              <figcaption className="text-lg font-semibold text-slate-900" data-id="element-25">
                {review.header}
              </figcaption>
              <blockquote className="mt-3 text-lg leading-relaxed text-slate-600" data-id="element-26">
                {review.text}
              </blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}